// src/constants/timeSlots.js
export const MASTER_TIME_SLOTS = [
  { id: 'lunch_1', label: '午餐時段 1', time: '11:00-11:45', category: 'lunch' },
  { id: 'lunch_2', label: '午餐時段 2', time: '11:45-12:30', category: 'lunch' },
  { id: 'lunch_3', label: '午餐時段 3', time: '12:30-13:15', category: 'lunch' },
  { id: 'lunch_4', label: '午餐時段 4', time: '13:15-14:00', category: 'lunch' },
  { id: 'lunch_5', label: '午餐時段 5', time: '14:00-14:45', category: 'lunch' },
  { id: 'lunch_6', label: '午餐時段 6', time: '14:45-15:30', category: 'lunch' },
  { id: 'dinner_1', label: '晚餐時段 1', time: '17:30-18:15', category: 'dinner' },
  { id: 'dinner_2', label: '晚餐時段 2', time: '18:15-19:00', category: 'dinner' },
  { id: 'dinner_3', label: '晚餐時段 3', time: '19:00-19:45', category: 'dinner' },
  { id: 'dinner_4', label: '晚餐時段 4', time: '19:45-20:30', category: 'dinner' },
  { id: 'dinner_5', label: '晚餐時段 5', time: '20:30-21:15', category: 'dinner' },
  { id: 'dinner_6', label: '晚餐時段 6', time: '21:15-22:00', category: 'dinner' }
];